import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { useSettingsQuery } from '@/hooks/queries/useSettingsQuery';
import { DataService } from '@/services/dataService';
import { queryKeys } from '@/hooks/queries/queryKeys';
import { CompanySettings } from '@/types';

export function useSettingsDomain() {
    const queryClient = useQueryClient();
    const { isAuthenticated, isLoading: authLoading } = useAuth();
    const enabled = isAuthenticated && !authLoading;

    const settingsQuery = useSettingsQuery(enabled);

    const updateSettings = useCallback(async (settings: CompanySettings) => {
        await DataService.updateSettings(settings);
        queryClient.invalidateQueries({ queryKey: queryKeys.settings });
    }, [queryClient]);

    const deleteAccount = useCallback(async () => {
        await DataService.deleteAccount();
        queryClient.invalidateQueries({ queryKey: queryKeys.settings });
    }, [queryClient]);

    return {
        // Data
        companySettings: settingsQuery.data || { 
            name: 'Parte Diario', 
            notifications: { 
                adminEmail: '', 
                adminPhone: '', 
                materialChannels: { email: false, whatsapp: false, sms: false }, 
                issueChannels: { email: false, whatsapp: false, sms: false } 
            } 
        } as CompanySettings,
        
        // Actions
        updateSettings,
        deleteAccount,
        
        // Loading States
        isLoading: settingsQuery.isLoading,
        isFetching: settingsQuery.isFetching,
        
        // Error state
        error: settingsQuery.error
    };
}
